import { getDaysSinceFirstMiniLogon } from './getDaysSinceFirstMiniLogon';

export const isUserNewToMini = (threshold: number): boolean => {
    return getDaysSinceFirstMiniLogon() <= threshold;
};
